import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  withStyles,
} from '@material-ui/core';
import React from 'react';

const CustomDialog = withStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(3),
  },
  paperWidthXs: {
    maxWidth: 400,
  },
}))(Dialog);

const CustomDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
}))(DialogContent);

const LoadingSpinner = withStyles((theme) => ({
  root: {
    color: '#1976d2',
    marginBottom: theme.spacing(3),
  },
}))(CircularProgress);

const LoadingText = withStyles((theme) => ({
  root: {
    color: '#333',
    fontWeight: 500,
    fontSize: 18,
    fontFamily: 'Lato',
  },
}))(Typography);

const ModalLoading = ({
  open = false,
  onClose,
  message = 'Please wait for a second',
  spinnerSize = 60,
  spinnerThickness = 4,
  disableBackdropClick = true,
  maxWidth = 'xs',
}) => {
  return (
    <CustomDialog
      maxWidth={maxWidth}
      fullWidth
      scroll="body"
      disableEnforceFocus
      disableBackdropClick={disableBackdropClick}
      open={open}
      onClose={onClose}
    >
      <CustomDialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <LoadingSpinner size={spinnerSize} thickness={spinnerThickness} />
          <LoadingText variant="h6">{message}</LoadingText>
        </Box>
      </CustomDialogContent>
    </CustomDialog>
  );
};

export default ModalLoading;
